<div class="w-full flex justify-center items-center">
	<section class="container w-full flex flex-col gap-2 justify-center items-center min-h-[50vh]">
		<img class="w-[80px] animate-bounce" src="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/logo_black.svg" alt="Anuprerna">
		<p class="text-3xl mb-5 animate-bounce">Anuprerna</p>
		<mat-progress-spinner mode="indeterminate"
							  color="primary"
							  diameter="30"></mat-progress-spinner>
	</section>

</div>
